export default __webpack_public_path__ + "static/media/05AW2AUG66.dae55670.jpg";